interface Stats {
  total: number
  active: number
  pending: number
  sold: number
  views: number
  messages: number
}

interface StatsBarProps {
  stats: Stats
  loading?: boolean
}

export function StatsBar({ stats, loading }: StatsBarProps) {
  if (loading) {
    return (
      <div className="mp-stats">
        <div className="mp-stats__pill mp-stats__pill--skeleton"></div>
        <div className="mp-stats__pill mp-stats__pill--skeleton"></div>
        <div className="mp-stats__pill mp-stats__pill--skeleton"></div>
      </div>
    )
  }

  return (
    <div className="mp-stats">
      <div className="mp-stats__pill mp-stats__pill--primary">
        <i className="bi bi-box-seam"></i>
        <span>{stats.total}</span>
        <span className="mp-stats__label">מודעות</span>
      </div>
      <div className="mp-stats__pill mp-stats__pill--success">
        <i className="bi bi-check-circle"></i>
        <span>{stats.active}</span>
        <span className="mp-stats__label">פעילות</span>
      </div>
      <div className="mp-stats__pill mp-stats__pill--info">
        <i className="bi bi-eye"></i>
        <span>{stats.views.toLocaleString()}</span>
        <span className="mp-stats__label">צפיות</span>
      </div>
      <div className="mp-stats__pill mp-stats__pill--warning">
        <i className="bi bi-chat-dots"></i>
        <span>{stats.messages}</span>
        <span className="mp-stats__label">הודעות</span>
      </div>
    </div>
  )
}
